
import axios from 'axios'
import { genURL } from "../../_getjson";
// check 
export default async function Checkwarehousepermission(type, txt, usercode, productcode) {
    console.log("type:", type, " txt:", txt, " usercode:", usercode, "  productcode:", productcode);
    // return
    let url = `STKWAREHOUSE/CSVSTKWarehouseaspermission?usercode=` + usercode + `&productcode=` + productcode
    //  let T_Warehouse = "", T_StorageIn = ""
    let rs = await axios.get(genURL((url)), { timeout: 3600 });
    let warehouse = "", location = ""
    console.log("STKWAREHOUSErs.data", rs.data)

    if (rs.data.length > 0) {
        for (let index = 0; index < rs.data.length; index++) {
            if (type === "warehouse" && rs.data[index].WAREHOUSE === txt) {

                warehouse = rs.data[index].WAREHOUSE
                if (rs.data[index].LOCATION === rs.data[index].WAREHOUSE + "001") location = rs.data[index].LOCATION

            }
            if (type === "location" && rs.data[index].LOCATION === txt) {
                if (index === 0) {
                    warehouse = rs.data[index].WAREHOUSE
                    location = rs.data[index].LOCATION
                }
            }
        }
        // console.log(warehouse, location);
    }
    //console.log(warehouse, location);
    return await [warehouse, location]

}